import { FileText, Image as ImageIcon, ExternalLink } from 'lucide-react';

/**
 * EvidenceViewer — inline gallery of refund/dispute evidence URLs.
 *
 * Images render as thumbnails that open the full asset in a new tab.
 * PDFs render as a clickable link with a filetype icon. Anything else
 * (unlikely — backend only accepts jpg/png/pdf) falls back to a generic
 * link.
 */
export default function EvidenceViewer({ urls = [], title = 'Evidence' }) {
  if (!urls || urls.length === 0) {
    return (
      <div
        className="text-xs text-gray-500 italic"
        data-testid="evidence-empty"
      >
        No evidence attached.
      </div>
    );
  }

  const _isImage = (u) => /\.(jpe?g|png|webp|gif)(\?|$)/i.test(u);
  const _isPdf = (u) => /\.pdf(\?|$)/i.test(u);

  return (
    <div className="space-y-2" data-testid="evidence-viewer">
      <div className="text-xs font-medium text-gray-600">{title}</div>
      <div className="flex flex-wrap gap-2">
        {urls.map((u, i) => (
          <a
            key={`${u}-${i}`}
            href={u}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`evidence-item-${i}`}
            className="group relative block"
          >
            {_isImage(u) ? (
              <img
                src={u}
                alt={`evidence-${i}`}
                className="h-20 w-20 rounded-md object-cover border border-gray-200 group-hover:border-emerald-500 transition-colors"
              />
            ) : _isPdf(u) ? (
              <div className="h-20 w-20 rounded-md border border-gray-200 group-hover:border-emerald-500 flex flex-col items-center justify-center bg-gray-50 gap-1 transition-colors">
                <FileText className="w-6 h-6 text-red-600" />
                <span className="text-[10px] text-gray-600">PDF</span>
              </div>
            ) : (
              <div className="h-20 w-20 rounded-md border border-gray-200 flex flex-col items-center justify-center bg-gray-50 gap-1">
                <ExternalLink className="w-5 h-5 text-gray-500" />
                <span className="text-[10px] text-gray-600 truncate w-16 text-center">
                  file
                </span>
              </div>
            )}
          </a>
        ))}
      </div>
    </div>
  );
}
